import styled from 'styled-components/macro';

export const Threedots = styled.li`
font-size:10px;
font-weight:300;
height:6px;
`